<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="外发单号"><el-input v-model="query.distributionNo" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="伙伴"><el-input v-model="query.partnerName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="审核">
        <el-select v-model="query.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" /><el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmDocDistribution:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmDocDistribution:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="code" label="外发单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmDocDistribution:info') || isAuth('plm:plmDocDistribution:update')" class="code-link" @click="open(scope.row)">{{ scope.row.code }}</a>
          <span v-else>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="partnerName" label="伙伴" min-width="120" header-align="center" align="left" />
      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.approveStatus === '2' ? 'success' : 'info'" size="mini">{{ scope.row.approveStatus === '2' ? '已审' : '未审' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmDocDistribution:update')" type="text" size="small" :disabled="scope.row.approveStatus === '2'" @click="open(scope.row)">修改</el-button>
          <el-button v-if="isAuth('plm:plmDocDistribution:delete')" type="text" size="small" :disabled="scope.row.approveStatus === '2'" @click="removeRow(scope.row.id)">删除</el-button>
          <el-button v-if="isAuth('plm:plmDocDistribution:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row.id)">审核</el-button>
          <el-button v-if="isAuth('plm:plmDocDistribution:unapprove') && scope.row.approveStatus === '2'" type="text" size="small" @click="unapprove(scope.row.id)">弃审</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="form.id ? '修改图纸外发' : '新增图纸外发'" :visible.sync="visible" width="min(620px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="外发单号" prop="distributionNo"><el-input v-model="form.distributionNo" :disabled="!canEdit || !!form.id" /></el-form-item>
        <el-form-item label="伙伴" prop="partnerName"><el-input v-model="form.partnerName" :disabled="!canEdit" /></el-form-item>
        <el-form-item label="外发文档">
          <el-button type="primary" plain size="mini" :disabled="!canEdit" @click="openDocPicker">选择文档</el-button>
          <div style="margin-top:8px">
            <el-tag v-for="item in selectedDocs" :key="item.documentId" :closable="canEdit" style="margin-right:6px;margin-bottom:6px" @close="removeDoc(item.documentId)">
              {{ item.documentCode || item.documentId }}
            </el-tag>
            <span v-if="!selectedDocs.length" class="text-muted">请选择至少一个文档</span>
          </div>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" :disabled="!canEdit" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="canEdit" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择文档" :visible.sync="docPickerVisible" width="min(720px, calc(100vw - 24px))" append-to-body>
      <el-table :data="docList" border height="360" @selection-change="onDocSelection">
        <el-table-column type="selection" width="50" />
        <el-table-column prop="documentCode" label="文档编号" min-width="120" />
        <el-table-column prop="documentName" label="文档名称" min-width="160" />
      </el-table>
      <span slot="footer">
        <el-button @click="docPickerVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDocPicker">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PlmDocDistribution',
  data() {
    return {
      query: { distributionNo: '', partnerName: '', approveStatus: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, permCodes: [], form: {},
      selectedDocs: [], docPickerVisible: false, docList: [], docPickerSelection: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        distributionNo: [{ required: true, message: '外发单号不能为空', trigger: 'blur' }],
        partnerName: [{ required: true, message: '伙伴不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    canEdit() {
      if (this.form.approveStatus === '2') return false
      return this.form.id
        ? (this.isAuth('plm:plmDocDistribution:update') || this.isAuth('plm:plmDocDistribution:save'))
        : this.isAuth('plm:plmDocDistribution:save')
    },
    filtered() {
      return this.list.filter(row => this.has(row.code, this.query.distributionNo) && this.has(row.partnerName, this.query.partnerName) && (!this.query.approveStatus || row.approveStatus === this.query.approveStatus))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/distribution/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(row) {
      this.visible = true
      const blank = () => ({ id: '', distributionNo: '', partnerName: '', remark: '', approveStatus: '0' })
      if (!row || !row.id) {
        this.form = blank()
        this.selectedDocs = []
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/distribution/info', { params: { id: row.id } }).then(res => {
        const data = res.data || {}
        this.form = {
          id: data.id || row.id,
          distributionNo: data.distributionNo || data.code || row.code || '',
          partnerName: data.partnerName || row.partnerName || '',
          remark: data.remark || '',
          approveStatus: String(data.approveStatus != null ? data.approveStatus : row.approveStatus || '0')
        }
        this.selectedDocs = (data.lines || []).map(l => ({ documentId: l.documentId, documentCode: l.documentCode, documentName: l.documentName }))
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = { id: row.id, distributionNo: row.code || '', partnerName: row.partnerName || '', remark: row.remark || '', approveStatus: String(row.approveStatus || '0') }
        this.selectedDocs = []
      })
    },
    openDocPicker() {
      request.get('/plm/document/list').then(res => { this.docList = res.data || [] }).catch(() => { this.docList = [] })
      this.docPickerVisible = true
    },
    onDocSelection(rows) { this.docPickerSelection = rows || [] },
    confirmDocPicker() {
      const map = {}
      this.selectedDocs.forEach(d => { map[d.documentId] = d })
      this.docPickerSelection.forEach(d => { map[d.documentId] = { documentId: d.documentId, documentCode: d.documentCode, documentName: d.documentName } })
      this.selectedDocs = Object.values(map)
      this.docPickerVisible = false
    },
    removeDoc(documentId) {
      this.selectedDocs = this.selectedDocs.filter(d => d.documentId !== documentId)
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.selectedDocs.length) {
          this.$message.warning('请选择至少一个文档')
          return
        }
        request.post('/plm/distribution/save', {
          id: this.form.id,
          distributionNo: this.form.distributionNo,
          partnerName: this.form.partnerName,
          remark: this.form.remark,
          lines: this.selectedDocs.map(d => ({ documentId: d.documentId }))
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    removeRow(id) {
      this.$confirm('确定删除该图纸外发单?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/distribution/delete', { id }).then(() => { this.$message.success('删除成功'); this.load() }).catch(() => {})
      }).catch(() => {})
    },
    approve(id) {
      request.post('/plm/distribution/approve', { id }).then(() => { this.$message.success('审核成功'); this.load() }).catch(() => {})
    },
    unapprove(id) {
      request.post('/plm/distribution/unapprove', { id }).then(() => { this.$message.success('弃审成功'); this.load() }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.text-muted { color: #909399; }
</style>
